// extracted by mini-css-extract-plugin
export default {"root":"EEfXOlRV0b_udGsYVUPW"};